export { V };
class V {
    static add(a, b) {
        return [a[0] + b[0], a[1] + b[1]];
    }
    static subtract(a, b) {
        return [a[0] - b[0], a[1] - b[1]];
    }
    static norm(v) {
        return Math.hypot(v[0], v[1]);
    }
    static normalize(v) {
        return V.toLength(v, 1);
    }
    static toLength(v, length) {
        return V.multiply(v, length / V.norm(v));
    }
    static squaredNorm(v) {
        return V.dot(v, v);
    }
    static distance(a, b) {
        return V.norm(V.subtract(a, b));
    }
    static dot(a, b) {
        return a[0] * b[0] + a[1] * b[1];
    }
    static cross(a, b) {
        return a[0] * b[1] - a[1] * b[0];
    }
    static multiply(v, f) {
        return [v[0] * f, v[1] * f];
    }
    static leftOrthogonal(v) {
        return [v[1] !== 0 ? -v[1] : 0, v[0]];
    }
    static rightOrthogonal(v) {
        return [v[1], v[0] !== 0 ? -v[0] : 0];
    }
    static equals(a, b) {
        return a[0] === b[0] && a[1] === b[1];
    }
    static isClose(a, b, epsilon) {
        return Math.abs(a[0] - b[0]) < epsilon && Math.abs(a[1] - b[1]) < epsilon;
    }
    static angle(v) {
        return Math.atan2(v[1], v[0]);
    }
}
//# sourceMappingURL=Vector.js.map